// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_dashboard__EkYP+","row":"Dashboard_row__U5u2U"};